module.exports = __webpack_public_path__ + "img/plan_name_green.c37523ca.svg";